import React from 'react'
import { Card, CardHeader, CardContent, CardActions, Typography, LinearProgress } from '@mui/material'
import { useLoading } from 'react-admin'

export const CardCommon = ({ headerStyle, className, loading: propsLoading, ...props }) => {
  let raLoading = false
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    raLoading = useLoading()
  } catch (e) {
    raLoading = false
  }

  const isLoading = propsLoading !== undefined ? propsLoading : raLoading

  return (
    <Card className={`uiCardCommon ${className}`} variant='outlined' style={{ position: 'relative' }} {...props}>
      {isLoading && (
        <LinearProgress
          color='primary'
          sx={{
            height: 3,
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 10,
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit',
          }}
        />
      )}
      {/* se usa customTitle para que no aparezca el tooltip automático en títulos que son componentes jsx */}
      {(props.title || props.customTitle) && props.subtitle && (
        <CardHeader
          disableTypography
          action={props.headerAction || props.actionHeader || props.action}
          title={
            <Typography className='card-header-title' variant='h6'>
              {props.title || props.customTitle}
            </Typography>
          }
          subtitle={
            <Typography className='card-header-subtitle' variant='body2'>
              {props.subtitle}
            </Typography>
          }
        />
      )}
      {(props.title || props.customTitle) && !props.subtitle && (
        <CardHeader
          style={headerStyle}
          disableTypography
          action={props.headerAction || props.actionHeader || props.action}
          title={
            <Typography className='card-header-title mb-0' variant='h6'>
              {props.title || props.customTitle}
            </Typography>
          }
        />
      )}
      <CardContent>{props.children}</CardContent>
      {props.actions && <CardActions className='cardActions'>{props.actions}</CardActions>}
    </Card>
  )
}